import React, { useEffect, useState } from "react";
import { get_user_auth } from "../../Controllers/Layouts/Layouts";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";


const Container = (props) => {

  let navigate = useNavigate();

  const fetchData = async (tabledata) => {
    try {
      const layouts = await get_user_auth();

      if (layouts?.message === "Logout") {
        localStorage.clear();
        navigate("/signin");
        toast?.success(layouts?.message);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return <div className="px-4 flex-1 overflow-hidden flex flex-col" >{props?.children}</div>;
};

export default Container;
